module.exports = __webpack_public_path__ + "img/img_level_10.1b1065ff.png";